class CartNote extends HTMLElement {
  constructor() {
    super();

    this.addEventListener(
      'input',
      debounce((event) => {
        const body = JSON.stringify({ note: event.target.value });
        fetch(`${routes.cart_update_url}`, { ...{
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        }, ...{ body } });
      }, ON_CHANGE_DEBOUNCE_TIMER)
    );
  }
};

document.addEventListener('DOMContentLoaded', () => {
  if (!customElements.get('cart-note')) {
    customElements.define('cart-note', CartNote);
  }
});